import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { ENV } from './app/core/enum/enum';
import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: 'https://2e84d20026c38da3cf40105e33e8db59@o4504514821947392.ingest.us.sentry.io/4510086104743936',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: [
    'https://health-registration.kimbocare.com',
    'https://health-registration.kimbocare.training',
  ],
  tracesSampleRate: 1,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

if (environment.production) {
  enableProdMode();
  if (window) {
    if (environment.name === ENV.production)
      window.console.log = function () {};
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
